import { useState, useRef, useEffect } from "react";
import { Languages, Check } from "lucide-react";
import { LANGUAGES } from "../i18n/languages";
import { useLanguage } from "../context/LanguageContext";

export function LanguageSelector({ compact }) {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find((l) => l.code === language) || LANGUAGES[0];

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button data-testid="language-selector-button" onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1.5 text-sm text-neutral-600 dark:text-neutral-300 hover:text-[#111] dark:hover:text-white transition-colors px-2 py-1.5 rounded-md">
        <Languages className="w-4 h-4" />
        {!compact && <span>{current.label}</span>}
      </button>
      {open && (
        <div data-testid="language-selector-menu" className="absolute right-0 rtl:right-auto rtl:left-0 mt-2 w-40 bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-lg shadow-lg py-1.5 z-50">
          {LANGUAGES.map((l) => (
            <button key={l.code} data-testid={`language-option-${l.code}`}
              onClick={() => { setLanguage(l.code); setOpen(false); }}
              className="w-full flex items-center justify-between gap-2 px-3.5 py-2 text-sm text-neutral-700 dark:text-neutral-200 hover:bg-neutral-50 dark:hover:bg-neutral-800 transition-colors">
              {l.label}
              {l.code === language && <Check className="w-3.5 h-3.5 text-[#111] dark:text-white" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
